import { AlbumLocation, AlbumStatus, Clonable, StorageFolder } from '../../..';

export enum AlbumSharingType {
  DomainUsers = 'domain-users',
  Groups = 'groups',
  Users = 'users',
}

export type AlbumWithLocation = Album & { location: AlbumLocation };

export class Album extends Clonable {
  constructor(
    public readonly id: string,
    public readonly availableToDomainUsers: boolean,
    public readonly createdAt: Date,
    public readonly createdBy: string | undefined,
    public readonly description: string | undefined,
    public readonly folder: StorageFolder,
    public readonly groups: string[],
    public readonly internalId: string | undefined,
    public readonly isPublic: boolean,
    public readonly isUserDefaultAlbum: boolean,
    public readonly location: AlbumLocation | undefined,
    public readonly name: string,
    public readonly publicPasswordHash: string | undefined,
    public readonly systemStatus: AlbumStatus,
    public readonly teamId: string,
    public readonly users: string[],
  ) {
    super();
  }

  public hasLocation(): this is AlbumWithLocation {
    return !!this.location;
  }

  public hasPublicPassword(): boolean {
    return !!this.publicPasswordHash;
  }

  public get isActive(): boolean {
    return this.systemStatus === AlbumStatus.Active;
  }

  public get isArchived(): boolean {
    return this.systemStatus === AlbumStatus.Archived;
  }

  public get sharingType(): AlbumSharingType {
    if (this.availableToDomainUsers) {
      return AlbumSharingType.DomainUsers;
    } else if (this.groups.length) {
      return AlbumSharingType.Groups;
    }

    return AlbumSharingType.Users;
  }
}
